import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { ARTICLES } from "../data/articles";

const fmt = (d) => new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

/* Homepage: three newest English insights — freshness signal + internal links */
const LatestInsights = () => {
  const items = [...ARTICLES].filter((a) => a.lang === "en").sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 3);
  return (
    <section className="relative py-14 sm:py-20 glow-top border-t border-white/[0.06]" data-testid="latest-insights-section">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-10">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="text-[10px] tracking-[0.5em] uppercase text-purple-300">Latest insights</div>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl text-zinc-100 tracking-tight">
              Fresh thinking for <em className="not-italic gold-text">founders launching now.</em>
            </h2>
          </div>
          <Link to="/insights" className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-purple-200 hover:text-[#FFE9A8] transition-colors" data-testid="latest-insights-all">
            All insights <ArrowRight size={13} />
          </Link>
        </div>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {items.map((a, i) => (
            <motion.div
              key={a.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            >
              <Link
                to={`/insights/${a.slug}`}
                className="lux-card group block h-full rounded-2xl p-6 hover:-translate-y-1 transition-transform"
                data-testid={`latest-insight-${i}`}
              >
                <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                  <span className="text-purple-300">{a.tag}</span>
                  <span>·</span>
                  <span>{fmt(a.date)}</span>
                </div>
                <h3 className="font-display mt-3 text-lg text-zinc-100 leading-snug group-hover:text-[#FFE9A8] transition-colors">{a.title}</h3>
                <p className="mt-3 text-[13px] text-zinc-400 leading-relaxed line-clamp-3">{a.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-[11px] text-zinc-500">
                  <span className="inline-flex items-center gap-1.5"><Clock size={11} /> {a.minutes} min</span>
                  <span className="inline-flex items-center gap-1 text-purple-200 group-hover:text-[#FFE9A8] transition-colors">Read <ArrowRight size={12} /></span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestInsights;
